module.exports = __webpack_public_path__ + "static/tlincalli-dfa4a32680ffe985aed7e900b8b21ce9.jpeg";